import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import fieldLogic from '../logic/fieldsLogic';
import NumberInput from '../controls/NumberInput';
import useInputRef from './useInputRef';
import Typography from '@material-ui/core/Typography';
import StyledText from './StyledTextInput';
import utils from '../utils';
/**
 *
 * @param {import('../components/types').FormFieldTextBoxProps} props
 */

var CurrencyFieldText = function CurrencyFieldText(props) {
  var description = props.description,
      placeholder = props.placeholder,
      error = props.error,
      readonly = props.readonly,
      format = props.format;
  var value = props.value,
      active = props.active,
      fieldId = props.fieldId,
      dispatch = props.dispatch,
      variant = props.variant;
  var parseFormatResult = utils.formats.parse('currency:' + format);
  var mask = parseFormatResult.format.split('#').join('_').split('0').join('_');
  var thousandSeparator = parseFormatResult.thousandsSeparator,
      decimalSeparator = parseFormatResult.decimalsSeparator,
      suffix = parseFormatResult.suffix,
      prefix = parseFormatResult.prefix,
      decimalPlaces = parseFormatResult.decimalPlaces;
  var onValueChange = props.onChange;

  var _useInputRef = useInputRef(active),
      _useInputRef2 = _slicedToArray(_useInputRef, 1),
      inputRef = _useInputRef2[0];

  var onChange = function onChange(event) {
    if (onValueChange) return onValueChange(event.target.value);
    fieldLogic.onChange(fieldId, event.target.value, dispatch);
  };

  var onFocus = function onFocus() {
    return fieldLogic.onFocus(fieldId, dispatch);
  };

  var onBlur = function onBlur() {
    return fieldLogic.onBlur(fieldId, dispatch);
  };

  var hasError = !!error;
  var InputProps = {
    inputComponent: NumberInput
  };
  var inputProps = {
    thousandSeparator: thousandSeparator,
    decimalSeparator: decimalSeparator,
    suffix: suffix ? ' ' + suffix : suffix,
    prefix: prefix ? prefix + ' ' : prefix,
    decimalScale: decimalPlaces,
    fixedDecimalScale: decimalPlaces > 0,
    isNumericString: true
  };
  return React.createElement(StyledText, {
    InputProps: InputProps,
    inputProps: _objectSpread({}, inputProps),
    error: hasError,
    helperText: error || description || React.createElement(Typography, null, " "),
    placeholder: placeholder || mask,
    disabled: readonly,
    value: value || '',
    variant: variant,
    inputRef: inputRef,
    onBlur: onBlur,
    onFocus: onFocus,
    onChange: onChange
  });
};

export default React.memo(CurrencyFieldText);